import { createSelector, MemoizedSelector } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { LoyaltyQrResponse } from '@user/const';
import { CustomUserState, StateWithCustomUser } from '../user-state';
import { getCustomUserState } from './feature.selector';

export const getLoyaltyQrState: MemoizedSelector<
  StateWithCustomUser,
  StateUtils.LoaderState<LoyaltyQrResponse>
> = createSelector(getCustomUserState, (state: CustomUserState) => state.loyaltyQr);

export const getLoyaltyQrLoading: MemoizedSelector<StateWithCustomUser, boolean> = createSelector(
  getLoyaltyQrState,
  (state: StateUtils.LoaderState<LoyaltyQrResponse>) => StateUtils.loaderLoadingSelector(state),
);

export const getLoyaltyQrError: MemoizedSelector<StateWithCustomUser, boolean> = createSelector(
  getLoyaltyQrState,
  (state: StateUtils.LoaderState<LoyaltyQrResponse>) => StateUtils.loaderErrorSelector(state),
);

export const getLoyaltyQrSuccess: MemoizedSelector<StateWithCustomUser, boolean> = createSelector(
  getLoyaltyQrState,
  (state: StateUtils.LoaderState<LoyaltyQrResponse>) => StateUtils.loaderSuccessSelector(state),
);

export const getLoyaltyQrValue: MemoizedSelector<StateWithCustomUser, LoyaltyQrResponse> = createSelector(
  getLoyaltyQrState,
  (state: StateUtils.LoaderState<LoyaltyQrResponse>) => StateUtils.loaderValueSelector(state),
);
